import React from "react";
import "./Profile.scss"; // Si vous souhaitez ajouter du style
import profileImage from "../../assets/images/maintenance.jpg";

const Seller = () => {
  return (
    <div className="profile">
      <div className="container">
        <h2>Support not yet available 🙏</h2>
        <img
          src={profileImage}
          alt={`profile`}
          className="profile-image"
        />
      </div>
    </div>
  );
};

export default Seller;
